// src/layouts/scenarios/create/components/scenarioMap/layers/symbolLayer.js

import defaultIconLayer from "assets/images/Synchro/events-icons/accident.png";

// ---------------------------------------------------------------------------
// Helper 1: accepts an array or an object with { items: [...] }
// ---------------------------------------------------------------------------
export const toEventsArray = (eventsInput) => {
  if (Array.isArray(eventsInput)) return eventsInput;
  if (eventsInput && Array.isArray(eventsInput.items)) return eventsInput.items;
  return [];
};

// ---------------------------------------------------------------------------
// Helper 2: converts events to a FeatureCollection
// ---------------------------------------------------------------------------
export function eventsToGeoJSON(eventsInput) {
  const events = toEventsArray(eventsInput);

  return {
    type: "FeatureCollection",
    features: events
      .map((ev) => {
        const geom = ev.geometry;
        if (!geom || !geom.type || !geom.coordinates) return null;

        let pointCoords = null;

        if (geom.type === "Point") {
          const c = geom.coordinates;
          pointCoords = Array.isArray(c[0]) ? c[0] : c;
        } else if (geom.type === "LineString") {
          const coords = geom.coordinates;
          if (!coords.length) return null;
          pointCoords = coords[Math.floor(coords.length / 2)];
        } else return null;

        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: pointCoords,
          },
          properties: {
            id: ev.id,
            selected: !!ev.selected,
            name: ev.name || ev.label || "",
            hoverMessage: ev.label || ev.name || "",
          },
        };
      })
      .filter(Boolean),
  };
}

// ---------------------------------------------------------------------------
// Helper 3: load icons safely
// ---------------------------------------------------------------------------
export function ensureIcon(map, ev) {
  const src = ev.iconSrc || ev.icon || defaultIconLayer;
  const id = `event-icon-${ev.id}`;
  if (!src || !map?.isStyleLoaded()) return;

  if (!map.hasImage(id)) {
    map.loadImage(src, (err, img) => {
      if (err || !img) return;
      if (!map?.isStyleLoaded()) return;
      if (!map.hasImage(id)) map.addImage(id, img);
    });
  }
}

// ---------------------------------------------------------------------------
// MAIN: updates ONLY the source — not the layer
// ---------------------------------------------------------------------------
export function addOrUpdateEvents(map, eventsInput = []) {
  if (!map) return;

  const events = toEventsArray(eventsInput);

  // 1. load icons
  events.forEach((ev) => ensureIcon(map, ev));

  // 2. build geojson
  const geojson = eventsToGeoJSON(eventsInput);

  // 3. update source
  const source = map.getSource("scenario-events-source");
  if (source && source.setData) {
    source.setData(geojson);
  }
}
